import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { styled } from '@this/constants/themes';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

interface Response {
  external_url: string;
}

const ExternalConnections = () => {
  const [externalUrl, setExternalUrl] = useState<string | null>(null);

  const fetchUrl = async () => {
    const res = await axios.get<Response>('/aicalendar/external_connections.json');
    setExternalUrl(res.data.external_url);
  };

  // マウント時に1回発動
  useEffect(() => {
    fetchUrl();
  }, []);

  return (
    <TheContainer maxWidth="md">
      <TheTitle>外部サイトに接続します</TheTitle>
      <TheText>
        表示中のページから
        {externalUrl ? <Link href={externalUrl}> {externalUrl} </Link> : <>外部サイト</>}
        に移動しようとしています。
      </TheText>
      <TheText>
        <Link onClick={() => history.back()} style={{ cursor: 'pointer' }}>
          元のページに戻る
        </Link>
      </TheText>
      {externalUrl && (
        <TheButtonBox>
          <TheButton variant="contained" size="large" color="primary" href={externalUrl}>
            移動する
          </TheButton>
        </TheButtonBox>
      )}
    </TheContainer>
  );
};

const TheContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 54px - 64px - 40px);
  padding: 30px 50px;
  background: #fff;
  border-radius: 3px;
`;

const TheTitle = styled(Typography)`
  font-size: 16px;
  font-weight: bold;
`;

const TheText = styled(Typography)`
  margin-top: 12px;
  font-size: 12px;
`;

const TheButtonBox = styled(Box)`
  display: flex;
  margin-top: 24px;
`;

const TheButton = styled(Button)`
  margin: 0 auto;
  font-size: 14px;
`;

export default ExternalConnections;
